import {
  RELATIONSHIP_EVENT_COLUMN_PADDING_X,
  RELATIONSHIP_EVENT_COLUMN_PADDING_Y,
  RELATIONSHIP_EVENT_COLUMN_WIDTH,
  RELATIONSHIP_HEADER_HEIGHT,
  RELATIONSHIP_INTERSECTION_AGE_SIZE
} from "../..";
import Dimensions from "../dimensions";

const CARD_DOT_MARGIN_X = Dimensions.ITEM_CARD_EVENT_DOT_MARGIN_X;

export default {
  CARD_DOT_MARGIN: {
    top: 3,
    right: CARD_DOT_MARGIN_X,
    bottom: 0,
    left: CARD_DOT_MARGIN_X
  },
  CHILD_ARROW_PADDING_X: 2,
  CHILD_ARROW_PADDING_Y: 3,
  HEADER_HEIGHT: RELATIONSHIP_HEADER_HEIGHT,
  EVENT_COLUMN_WIDTH: RELATIONSHIP_EVENT_COLUMN_WIDTH,
  EVENT_COLUMN_PADDING_Y: RELATIONSHIP_EVENT_COLUMN_PADDING_Y,
  EVENT_COLUMN_PADDING_X: RELATIONSHIP_EVENT_COLUMN_PADDING_X,
  HEADER_COLOR_DOT_SIZE: 7,
  HEADER_COLOR_DOT_MARGIN_RIGHT: 6,
  RELATIONSHIP_INTERSECTION_AGE_SIZE: RELATIONSHIP_INTERSECTION_AGE_SIZE
};
